<template>
    <v-card v-if="wishlistEntry.product"
            :to="url()"
            class="pa-2 fill-height d-flex flex-column"
            flat
            tile>
        <v-img :src="productImageSrc(wishlistEntry.product)"
               class="flex-grow-0 mb-5"
               aspect-ratio="1">
            <card-image-overlay v-if="wishlistEntry.product.unavailable || !wishlistEntry.product.active || !wishlistEntry.product.available_in_country"
                                :unavailable="wishlistEntry.product.unavailable"
                                :inactive="!wishlistEntry.product.active"
                                :availableInCountry="wishlistEntry.product.available_in_country"/>
        </v-img>


        <!--<v-img v-if="wishlistEntry.product.required_rank"-->
               <!--class="wishlist-entry-card__rank mt-3 mr-3"-->
               <!--width="16px"-->
               <!--:src="wishlistEntry.product.required_rank.icon"></v-img>-->

        <p class="mb-0 white--text body-1 text-uppercase">
            {{ wishlistEntry.product.product_brand }}
        </p>

        <p class="mt-0 font-weight-bold body-1">
            {{ wishlistEntry.product.title }}
        </p>

        <v-progress-linear :value="calcPercentage(wishlistEntry.product.price)"
                           color="primary"
                           background-color="primary darken-1"
                           height="12"
                           class="mt-auto"
                           reactive>
            <template v-slot="{ value }">
                <span class="caption pr-1">
                    {{ wishlistEntry.product.price | number }} {{ $vuetify.lang.t('$vuetify.points.short') }}
                </span>
            </template>
        </v-progress-linear>
    </v-card>
</template>

<script>
    // utils
    import { ROUTE_PRODUCT_DETAILS } from '../../utils/constants';
    import CardImageOverlay from '../CardImageOverlay';

    export default {
        name: 'wishlist-entry-card',
        components: {
            CardImageOverlay,
        },
        props: {
            wishlistEntry: {
                required: true,
                type: Object,
            },
            accountBalance: {
                required: true,
                type: Number,
            },
        },
        methods: {
            url() {
                return { name: ROUTE_PRODUCT_DETAILS, params: { productId: this.wishlistEntry.product.id } };
            },
            calcPercentage(productPrice) {
                const percentage = this.accountBalance / productPrice * 100;
                return percentage > 100 ? 100 : percentage;
            },
            productImageSrc(product) {
                return product.images.length > 0 ? product.images[0].source : '//via.placeholder.com/150x150/a1a1a1/FF0000/?text=Fallback';
            },
        },
    }
</script>
